import React from 'react';
import {
    Card,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Theme,
    Typography,
    makeStyles,
    Fade,
    Box,
    Tooltip,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { IInformationCard } from './types';
import { WarboxSwitch } from '../Switch';

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        overflow: 'scroll',
    },
    margin: {
        marginBottom: '1em',
    },
    icon: {
        marginLeft: 10,
    },
    fontWeightMedium: {
        fontWeightBold: theme.typography.fontWeightMedium,
        fontWeight: 500,
    },
    headerContainer: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));

export const InformationCard = ({
    title,
    details,
    toggleButton,
    ...props
}: IInformationCard) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Fade in={Boolean(details)} timeout={600}>
            <Card className={classes.paper} {...props} elevation={0}>
                <Box className={classes.headerContainer}>
                    <Typography variant="h5">{title}</Typography>
                </Box>
                <Divider />
                <Table className={classes.margin}>
                    <TableBody>
                        {details?.map((detail) => (
                            <TableRow>
                                <TableCell className={classes.fontWeightMedium}>
                                    {detail.label}
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {detail.value}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                        {toggleButton && (
                            <TableRow>
                                <TableCell className={classes.fontWeightMedium}>
                                    {t('Buttons.Status')}
                                </TableCell>
                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        <Tooltip
                                            title={t(
                                                'Tooltips.ChangeStatusTo',
                                                {
                                                    status: toggleButton.checked
                                                        ? t(
                                                              'maintenancePackage.Inactive'
                                                          )
                                                        : t(
                                                              'maintenancePackage.Active'
                                                          ),
                                                }
                                            )}
                                            placement="top"
                                        >
                                            <WarboxSwitch
                                                checked={toggleButton.checked}
                                                onChange={toggleButton.onChange}
                                            />
                                        </Tooltip>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Card>
        </Fade>
    );
};
